import { GET_BORDEREAU_SUMMARIES } from '../../constants/actions/policies';

export function getBordereauSummaries(payload) {
    return {
        type: GET_BORDEREAU_SUMMARIES,
        payload,
    };
}
